import { slugReverter, capitalizeFirstLetterOfTitle, breedNameTextConverter, categoryTitleConverter } from '@/utils/converter'
import { categoriesPageDescription } from '@/components/landings/util/categoriesPageDescription'

const BUCKET = process.env.NEXT_PUBLIC_MEDIA_BUCKET
const ROOT_URL = process.env.NEXT_PUBLIC_ROOT_URL

const redirectMap = {
  samoa: '/puppies-for-sale/american-samoa',
  lowShedding: '/puppies-for-sale/hypoallergenic',
  'weimaraner-1': '/puppies-for-sale/weimaraner',
  'german-shepherd': '/puppies-for-sale/german-shepherd-dog',
  cavadoodles: '/puppies-for-sale/cavapoo',
  'golden-bernedoodle': '/puppies-for-sale/golden-mountain-doodle',
  'papi-tzu': '/puppies-for-sale/papastzu',
  'central-asian-shepherd-dog-1': '/puppies-for-sale/central-asian-shepherd-dog',
  mini: '/puppies-for-sale/small',
  family: '/puppies-for-sale/kid_friendly',
  doodles: '/puppies-for-sale/doodle',
  companion: '/puppies-for-sale/emotional_support',
  'Yorkie-Bichon-Mix': 'yorkie-bichon-mix',
  poodle: 'standard-poodle'
}

async function getRedirectPath (slug) {
  return redirectMap[slug]
}

const getMetaTagsData = (breed, variables, landingType, citySlug) => {
  const isNotEmptyObject = (obj) => Object.entries(obj).length !== 0 && obj.constructor === Object

  let title = 'Puppies for Sale | MawooPets.com'
  let description = 'Browse adorable puppies for sale from our network of 850+ trusted breeders. Live Customer Support. Nationwide Delivery. Start your search today!'
  let image = `${ROOT_URL}/mawoo_social_1600x906.png`
  let url = `${ROOT_URL}/`
  let name
  let slug

  if (landingType === 'breed' &&
    isNotEmptyObject(breed)) {
    title = `${breedNameTextConverter(breed?.name)} Puppies for Sale | MawooPets.com`
    description = `Browse adorable ${breed?.name} puppies for sale from our network of 1,000+ trusted breeders. Live Customer Support. Nationwide Delivery. Start your search today!`
    image = `${BUCKET}${breed?.coverPicture?.small}`
    url = `${ROOT_URL}/puppies-for-sale/${breed.slug}`
    name = breed?.name
    slug = breed?.slug
  } else if (landingType === 'category' && variables?.category) {
    title = `${categoryTitleConverter(variables?.category)} | MawooPets.com`
    description = categoriesPageDescription[variables?.category]
    url = `${ROOT_URL}/puppies-for-sale/${variables?.category}`
    name = variables?.category
    slug = variables?.category
  } else if (landingType === 'state') {
    title = `Puppies for Sale in ${variables?.stateName} | MawooPets.com`
    description = `Browse adorable puppies for sale in ${variables?.stateName} from our network of 1,000+ trusted breeders. Live Customer Support. Nationwide Delivery. Start your search today!`
    url = `${ROOT_URL}/puppies-for-sale/${variables?.stateSlug}`
    name = variables?.stateName
    slug = variables?.stateSlug
  } else if (landingType === 'breedState' &&
    isNotEmptyObject(breed)) {
    title = `${breedNameTextConverter(breed?.name)} Puppies for Sale in ${variables?.stateName} | MawooPets.com`
    description = `Browse adorable ${breed?.name} puppies for sale in ${variables?.stateName} from our network of 1,000+ trusted breeders. Live Customer Support. Nationwide Delivery. Start your search today!`
    image = `${BUCKET}${breed?.coverPicture?.small}`
    url = `${ROOT_URL}/puppies-for-sale/${breed.slug}/${variables?.stateSlug}`
    name = breed?.name
    slug = breed?.slug
  } else if (landingType === 'breedCity') {
    title = `${breedNameTextConverter(breed?.name)} Puppies for Sale in ${capitalizeFirstLetterOfTitle(slugReverter(citySlug))}, ${variables?.state} | MawooPets.com`
    description = `Browse adorable ${breed?.name} puppies for sale in ${capitalizeFirstLetterOfTitle(slugReverter(citySlug))}, ${variables?.state} from our network of 1,000+ trusted breeders. Live Customer Support. Nationwide Delivery. Start your search today!`
    image = `${BUCKET}${breed?.coverPicture?.small}`
    url = `${ROOT_URL}/puppies-for-sale/${breed.slug}/${variables?.stateSlug}/${citySlug}`
    name = breed?.name
    slug = breed?.slug
  }
  return { title, description, url, image, name, slug }
}

const getCoverImages = (category, breed, state) => {
  let coverImage = ''
  let mobileCoverImage = ''

  if (category) {
    coverImage = `/landing/category/cover/${category}.png`
    mobileCoverImage = `/landing/category/mobileCover/${category}.png`
  } else if (breed?.coverPicture?.small) {
    coverImage = `${BUCKET}${breed.coverPicture.small}`
    mobileCoverImage = `${BUCKET}${breed.mobileCoverPicture.small}`
  } else if (state?.coverPicture) {
    coverImage = `${BUCKET}${state.coverPicture.small}`
    mobileCoverImage = `${BUCKET}${state.mobileCoverPicture?.small}`
  } else {
    coverImage = '/landing/generic.webp'
    mobileCoverImage = '/landing/generic-mobile.webp'
  }

  return { coverImage, mobileCoverImage }
}

const getTitleAndDescription = (landingType, breed, category, variables, city) => {
  let title = ''
  let description = ''

  switch (landingType) {
    case 'breed':
      title = `${breedNameTextConverter(breed?.name)} Puppies for Sale`
      description = `Explore adorable ${breedNameTextConverter(breed?.name)} puppies from our network of 1,000+ caring breeders.`
      break

    case 'category':
      title = `${category.includes('Affordable') ? capitalizeFirstLetterOfTitle(category) : `${capitalizeFirstLetterOfTitle(category)} for Sale`}`
      description = `Explore adorable ${category} from our network of 1,000+ caring breeders.`
      break
      // /puppies-for-sale/[state]
    case 'state':
      title = `Puppies for Sale in ${variables?.stateName} `
      description = `Explore adorable puppies in ${variables?.stateName} from our network of 1,000+ caring breeders.`
      break
      // /puppies-for-sale/[breed]/[state]
    case 'breedState':
      title = `${breedNameTextConverter(breed?.name)} Puppies for Sale in ${variables?.stateName}`
      description = `Explore adorable ${breedNameTextConverter(breed?.name)}s in ${variables?.stateName} from our network of 1,000+ caring breeders.`
      break
      // /puppies-for-sale/[breed]/[state]/[city]
    case 'breedCity':
      title = `${breedNameTextConverter(breed?.name)} Puppies for Sale in ${city}, ${variables.state}`
      description = `Explore adorable ${breedNameTextConverter(breed?.name)}s in ${city}, ${variables.state} from our network of 1,000+ caring breeders.`
      break
      // /puppies-for-sale/[state]/[city]
    case 'stateCity':
      title = `Puppies for Sale in ${city}, ${variables.state}`
      description = `Explore adorable puppies in ${city}, ${variables.state} from our network of 1,000+ caring breeders.`
      break
    default:
      description = 'Explore adorable puppies from our network of 1,000+ caring breeders.'
      break
  }

  return { title, description }
}

const hasBreedAndStateQuery = (router) => Object.entries(router.query).length >= 2

export { getCoverImages, getTitleAndDescription, hasBreedAndStateQuery, getRedirectPath, getMetaTagsData }
